import React from "react";
import styled from "styled-components";
import useContentPoliticas from "../hooks/parameter/useContentPoliticas";
import useConfigs from "../hooks/useConfigs";

import useThemes from "../hooks/useThemes";
import Hero from "./HeroSection/Hero";

export const PageTerminosCondiciones = () => {
  window.scroll(0, 0)
  const { contentPoliticas } = useContentPoliticas();

    let bodyHTML = ""

    contentPoliticas?.length > 0 && contentPoliticas?.find(element =>{
    element?.texto_titulo === "Política de términos y condiciones" && (bodyHTML = element.texto_contenido)
  })

  const { backgroundWhite } = useThemes();
  const { fontSizeMultiplier } = useConfigs();

  return (
    <>
    {contentPoliticas ? 
      <DivContainer id='contBodyHTML'>
        <p dangerouslySetInnerHTML={{ __html: bodyHTML }} />
      </DivContainer>
      :
      <Container 
        background={backgroundWhite}
        fontsizemultiplier={fontSizeMultiplier}
      >
        <Hero
          title=""
          subtitle=""
          imgSrc="img/Servicios/Citas-turnos.jpg"
          color={backgroundWhite}
        />
        <div className='info-container'>
          <h1>Términos y Condiciones</h1>

          <p>
            Texto de ejemplo.
          </p>
        </div>
      </Container>
      }
    </>
  );
};

const Container = styled.div`
  background-color: ${(props) => props.background};

  .info-container {
    min-height: 60vh;
  }

  h1 {
    font-size: ${(props) => 60 * props.fontsizemultiplier};
    padding: 2rem 10%;
    margin-bottom: 0;
  }

  p {
    max-width: 1200px;
    font-size: ${(props) => 20 * props.fontsizemultiplier};
    padding: 2rem 10%;
    text-align: justify;
  }
`;

const DivContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  min-height: 400px;

  p {
    // align-selft: center;
    text-align: center;
    // width: 80%;

    img {
      margin-top: 2.5rem;
      width: 100% !important;
    }
  }
`;